import type { FieldErrors, FieldValues, Resolver } from 'react-hook-form';
import type { ZodType } from 'zod';

/**
 * Минимальный резолвер react-hook-form на основе zod: избавляет от отдельной
 * зависимости `@hookform/resolvers`. Поддерживает плоские формы — этого
 * достаточно для текущих экранов; для вложенных структур потребуется
 * раскладывать путь issue.path по объекту.
 */
export function zodResolver<TFieldValues extends FieldValues>(
  schema: ZodType<TFieldValues>,
): Resolver<TFieldValues> {
  return async (values) => {
    const result = schema.safeParse(values);

    if (result.success) {
      return { values: result.data, errors: {} };
    }

    const errors: Record<string, { type: string; message: string }> = {};
    for (const issue of result.error.issues) {
      const key = issue.path.join('.');
      if (key !== '' && errors[key] === undefined) {
        errors[key] = { type: issue.code, message: issue.message };
      }
    }

    return {
      values: {},
      errors: errors as unknown as FieldErrors<TFieldValues>,
    };
  };
}
